/**
 * Created by Victor Rojo on 10/10/18.
 */
import { Component, Input }     from '@angular/core';
import { Router, ActivatedRoute, Params }                   from '@angular/router';



@Component({
  templateUrl: './IPlaceDashboard.component.html',
  styleUrls: ['./IPlaceDashboard.component.css']
})
export class IPlaceDashboardComponent {

  id:any;


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe((params: Params) => { this.onRouteParamsChange(params) });
  }

  onRouteParamsChange(params: Params){
    let iPlaceId = params["iPlaceId"];
    let sectionId = params["sectionId"];
    let data = {
      iPlaceId: iPlaceId,
      sectionId: sectionId
    };
    this.id = data;
  }

}
